module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_3009.f1d22a60.png";